module.exports = __webpack_public_path__ + "img/sx.8d3d0e5d.svg";